export default __webpack_public_path__ + "static/media/sabin.152e1f2b.png";